import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

const version = import.meta.env.VITE_APP_VERSION || Date.now();

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    supportedLngs: ["en", "tr"],
    fallbackLng: ["en", "tr"],
    returnObjects: false,
    backend: {
      // Adding version after load path makes sure that the translations are always up to date after a deployment
      loadPath: `/locales/{{lng}}/{{ns}}.json?${version}`,
    },
    ns: ["common"],
    defaultNS: "common",
  });

export default i18n;
